const EARTH_RADIUS = 6372.795;

const toRad = (value: number): number => {
  return (value * Math.PI) / 180;
};

export const getDistance = (sh1: number, dl1: number, sh2: number, dl2: number): number => {
  if (typeof sh1 === 'number' && typeof sh2 === 'number' && typeof dl1 === 'number' && typeof dl2 === 'number') {
    const { acos, sin, cos } = Math;
    return EARTH_RADIUS * acos(sin(toRad(sh1)) * sin(toRad(sh2)) + cos(toRad(sh1)) * cos(toRad(sh2)) * cos(toRad(dl2) - toRad(dl1)));
  } else {
    return 0;
  }
};

export const formatDistance = (distance: number): string => {
  if (typeof distance === 'number') {
    if (distance > 1) {
      return Math.round(distance) + ' км от вас';
    } else if (Math.round(distance * 1000) < 100) {
      return 'Вы рядом';
    } else {
      return Math.round(distance * 1000) + ' м от вас';
    }
  } else {
    return '';
  }
};
